import classNames from "classnames";

import type {ISearchComboboxInlineAction} from "../types/ISearchComboboxInlineAction";

interface IProps extends ISearchComboboxInlineAction {
    baseClassName: string;
    activeClassName: string;
}

/**
 * Text option shared by the group action ("Wyczyść"), the banner action ("Spróbuj ponownie") and the empty-state
 * chips. The parent supplies the look; the `option` role and `aria-selected` fall back to static values when the
 * props do not come from `getOptionProps(id)` (stories, static markup).
 */
export const SearchComboboxInlineOption = (props: IProps) => {
    const {label, isActive, className, dataTestId, baseClassName, activeClassName, ...optionProps} = props;
    const isActiveResolved = isActive ?? optionProps["aria-selected"] === true;

    return (
        <div
            role="option"
            aria-selected={false}
            {...optionProps}
            className={classNames(baseClassName, isActiveResolved && activeClassName, className)}
            data-testid={dataTestId}
        >
            {label}
        </div>
    );
};
import classNames from "classnames";

import type {ISearchComboboxInlineAction} from "../types/ISearchComboboxInlineAction";

interface IProps extends ISearchComboboxInlineAction {
    baseClassName: string;
    activeClassName: string;
}

/**
 * Text option shared by the group action ("Wyczyść"), the banner action ("Spróbuj ponownie") and the empty-state
 * chips. The parent supplies the look; the `option` role and `aria-selected` fall back to static values when the
 * props do not come from `getOptionProps(id)` (stories, static markup).
 */
export const SearchComboboxInlineOption = (props: IProps) => {
    const {label, isActive, className, dataTestId, baseClassName, activeClassName, ...optionProps} = props;
    const isActiveResolved = isActive ?? optionProps["aria-selected"] === true;

    return (
        <div
            role="option"
            aria-selected={false}
            {...optionProps}
            className={classNames(baseClassName, isActiveResolved && activeClassName, className)}
            data-testid={dataTestId}
        >
            {label}
        </div>
    );
};
